import * as React from "react";
import { useState } from "react";
import styled, { css } from "styled-components";
import Button from "components/bootstrap/Button";
import OverlayDropdown from "components/common/OverlayDropdown";
import { Icon } from "components/common/index";
const ToolbarSafeOverlayDropdown = styled(OverlayDropdown)(
  () => css`
    display: flex;
    align-items: center;
    flex: 0 0 auto;
    line-height: 1;

    .dropdown.btn-group {
      display: flex;
      align-items: center;
      flex: 0 0 auto;
    }

    .dropdown-toggle {
      display: flex;
      align-items: center;
      flex: 0 0 auto;
    }
  `
);
const OverlayDropdownButton = ({
  alwaysShowCaret = false,
  bsSize = void 0,
  buttonTitle = void 0,
  children,
  closeOnSelect = true,
  disabled = false,
  dropdownZIndex = void 0,
  onToggle: onToggleProp = void 0,
  title
}) => {
  const [show, setShowDropdown] = useState(false);
  const _onToggle = () => {
    if (typeof onToggleProp === "function") {
      onToggleProp(!show);
    }
    setShowDropdown((cur) => !cur);
  };
  const onClose = () => {
    if (typeof onToggleProp === "function") {
      onToggleProp(!show);
    }
    setShowDropdown(false);
  };
  return /* @__PURE__ */ React.createElement(
    ToolbarSafeOverlayDropdown,
    {
      show,
      onClose,
      closeOnSelect,
      dropdownZIndex,
      alwaysShowCaret,
      toggleChild: /* @__PURE__ */ React.createElement("div", { className: `dropdown btn-group ${show ? "open" : ""}` }, /* @__PURE__ */ React.createElement(
        Button,
        {
          bsSize,
          className: "dropdown-toggle",
          "aria-label": buttonTitle,
          title: buttonTitle,
          disabled
        },
        title,
        " ",
        /* @__PURE__ */ React.createElement(Icon, { name: "arrow_drop_down" })
      )),
      placement: "bottom",
      onToggle: _onToggle
    },
    typeof children === "function" ? children({ toggleDropdown: _onToggle }) : children
  );
};
export default OverlayDropdownButton;
